import { formatUsdDisplayInteger } from "./ceilUsd";

/**
 * Shared display-only price shaping for packages/profile sidebar (SummaryPriceCard) and SummaryFooter.
 * No API calls; preserves existing ordering rules (GBP footer vs card differ by design).
 */

/**
 * @param {object|null|undefined} ourPrice — from SelectedResultContext
 * @param {(n: number) => number} [ilsToUsd]
 * @param {{ billableAttractionsIls?: number, priceUnavailable?: boolean, priceUnavailableLabel?: string }} [options]
 * @returns {{
 *   loading: boolean,
 *   cardPrimary: string|null,
 *   cardSecondary: string|null,
 *   footerPriceText: string|null — single line for SummaryFooter price row (matches prior markup)
 * }}
 */
export function getPackageProfilePriceDisplay(ourPrice, ilsToUsd, options = {}) {
  if (options?.priceUnavailable === true) {
    const label =
      options?.priceUnavailableLabel != null &&
      String(options.priceUnavailableLabel).trim() !== ""
        ? String(options.priceUnavailableLabel).trim()
        : "מחיר לא זמין";
    return {
      loading: false,
      cardPrimary: label,
      cardSecondary: null,
      footerPriceText: label,
    };
  }
  if (ourPrice?.priceWithCreditCardFee == null) {
    return {
      loading: true,
      cardPrimary: null,
      cardSecondary: null,
      footerPriceText: null,
    };
  }

  const billableExtra = Number(options?.billableAttractionsIls) || 0;

  const originalCurrency = ourPrice?.originalCurrency;
  const finalPriceGBP = ourPrice?.finalPriceGBP;
  const priceIls = ourPrice.priceWithCreditCardFee;
  const ilsTotal = Number(priceIls) + billableExtra;

  if (originalCurrency === "GBP" && finalPriceGBP) {
    const ilsRounded = Math.round(ilsTotal).toLocaleString();
    const gbpRounded = Math.round(Number(finalPriceGBP)).toLocaleString();
    return {
      loading: false,
      cardPrimary: `${ilsRounded} ₪`,
      cardSecondary: `(${gbpRounded} £)`,
      footerPriceText: `${gbpRounded} £ (${ilsRounded} ₪)`,
    };
  }

  const usdVal = typeof ilsToUsd === "function" ? Number(ilsToUsd(ilsTotal)) : 0;
  const usdStr = formatUsdDisplayInteger(Number.isFinite(usdVal) ? usdVal : 0);
  const ilsRounded = Math.round(ilsTotal).toLocaleString();
  return {
    loading: false,
    cardPrimary: `${ilsRounded}₪`,
    cardSecondary: `(${usdStr}$)`,
    footerPriceText: `${ilsRounded}₪ (${usdStr}$)`,
  };
}
